export enum ContentTemplateStatusType {
  UnSubmitted = "UnSubmitted",
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected"
}
